export const MenuItems = [
  {
    id: 1,
    title: "Home",
    url: "/",
    cName: "nav-links",
    icon: "fa-solid fa-house"
  },
  {
    id: 2,
    title: "About Us",
    url: "/about",
    cName: "nav-links",
    icon: "fa-solid fa-circle-info"
  },
  {
    id: 3,
    title: "Service",
    url: "/service",
    cName: "nav-links",
    icon: "fa-solid fa-briefcase"
  },
  // {
  //   id: 4,
  //   title: "Gallery",
  //   url: "/gallery",
  //   cName: "nav-links",
  //   icon: "fa-solid fa-image"
  // },
  {
    id: 5,
    title: "Contact",
    url: "/contact",
    cName: "nav-links",
    icon: "fa-solid fa-address-book"
  },
  // {
  //   title: "Sign Up",
  //   url: "/sign up",
  //   cName: "nav-links-mobile"
  // }
];


